"use strict";
import {FormGroup} from './form2/form.group.js';
import {} from './form2/datetime.combined.js';
import {} from './form2/clone.js';
//import {MultiFileSelect} from './form2/multi.file.select.js';
import {MultiFileSelect} from './form2/multi.file.select.new.js';
import {FormRollback} from './form2/form.rollback.js';

window.initDateTimeTypeCombined = ()=>console.warn('initDateTimeTypeCombined: DEPRECATED');
//window.Form2MultiFileSelect = {Init : MultiFileSelect};

window.initRanges=function(){
    const allRanges = document.querySelectorAll(".range-wrap");
    allRanges.forEach(wrap => {
        const rangeInput = wrap.querySelector(".range-input");
        const rangeOutputVal = wrap.querySelector(".range-output-value");

        if (Number(rangeInput?.dataset?.bubble)) {
            rangeInput.addEventListener("input", () => {
                setBubble(rangeInput, rangeOutputVal);
            });
            setBubble(rangeInput, rangeOutputVal);
        }
    });
}

function setBubble(rangeInput, rangeOutputVal) {
    const val = rangeInput.value;
    const min = rangeInput.min ? rangeInput.min : 0;
    const max = rangeInput.max ? rangeInput.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    rangeOutputVal.innerHTML = val;

    // Sorta magic numbers based on size of the native UI thumb
    rangeOutputVal.style.left = `calc(${ newVal }% + (${ 8 - newVal * 0.15 }px))`;
}

//*****************************


function initRollback() {
    try {
        if (window.VutRequiredLib.VutAjax) {
            [window.vutAjax, window.vutAjax2].forEach(vutajax => {
                if (vutajax instanceof window.VutRequiredLib.VutAjax) {
                    vutajax.addAfterAjax(FormRollback.initForms);
                }
            })
        }
    } catch(e) {
        console.error(e);
        console.error('Form2 Rollback : nelze svázat s VutAjax');
    }

/*  tudu
    try {
        if (window.initDatagrid2) {
            window.initDatagrid2.installComponent({FormRollback})
        }
    } catch(e) {
        console.error(e);
        console.error('Form2 Rollback : nelze svázat s Datagrid2');
    }
*/

    FormRollback.initForms();

}

window.addEventListener('DOMContentLoaded', initRanges);
window.addEventListener('DOMContentLoaded', initRollback);

window.rollbackForm = FormRollback.rollbackForm;
window.rollbackAll = FormRollback.rollbackAll;